import { TUserResponseType } from 'typings/userTypes';
import { homeSecurityPortalApi } from 'data/axios';
import { ApiResponse } from './HttpRequest';
import { endpoints } from './endpoints';

export async function GetUserDetails(
  authToken?: string
): Promise<ApiResponse<TUserResponseType>> {
  try {
    const response = await homeSecurityPortalApi.get(endpoints.getUser, {
      headers: { Authorization: `Bearer ${authToken}` }
    });
    console.log('API Response:', response); // Log response to inspect structure
    return response;
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error; // Ensure the error is propagated correctly
  }
}

export async function GetOneTimeToken() {
  const response = await homeSecurityPortalApi.get(endpoints.oneTimeToken);
  return response;
}

export async function VerifyOneTimeToken(oneTimeToken: string) {
  try {
    const response = await homeSecurityPortalApi.post(endpoints.verifyToken, {
      one_time_token: oneTimeToken
    });
    return response;
  } catch (error) {
    console.error('Error verifying one-time token:', error);
    throw error;
  }
}

export async function DeleteUserAccount() {
  try {
    const response = await homeSecurityPortalApi.delete(endpoints.deleteUser);
    return response;
  } catch (error) {
    console.error('Error fetching user details:', error);
    throw error; // Ensure the error is propagated correctly
  }
}

export async function InitiateDeleteUserAccount(email: string) {
  try {
    const response = await homeSecurityPortalApi.post(
      endpoints.requestAccountDelete,
      { email }
    );
    return response;
  } catch (error) {
    console.error('Error initiating account delete:', error);
    throw error;
  }
}
